import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import Input from '../../global/Input';

import {RadioButton} from 'primereact/radiobutton';
import {
    useCreatePersonMutation,
    useGetAnredeQuery, useGetCommentTypesQuery,
    useGetKontaktTypesQuery,
    useGetLegalFormTypesQuery,
    useGetLegalTypesQuery,
    useUpdatePersonMutation
} from '../../../redux/rtk/injectedPersonApi';
import {useCleanArray} from '../../hooks/useCleanArray';
import {showMessageOnError, showMessageOnSuccess} from '../../global/CustomToast';
import CustomDialog from '../../global/CustomDialog';
import {PersonOverview} from './PersonOverview';
import {Button} from 'primereact/button';
import {iterateOverKeys} from '../../functions/Global';
import {Mapping, MappingType, resetMappings} from '../../../redux/slices/MappingSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {useDeleteMappingMutation, useUpdateMappingMutation,} from '../../../redux/rtk/injectedMappingApi';
import {ParcelMapping} from '../parcel/ParcelMapping';
import {LandRegisterMapping} from '../landRegister/LandRegisterMapping';
import {checkPermission, getMappingsForUpdate, saveMappings} from '../../../functions/functionLibrary';
import {PersonMapping} from './PersonMapping';
import {useLazyGetHereAddressQuery,} from '../../../redux/rtk/injectedHereAddressApi';
import {classNames} from 'primereact/utils';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {AddressForm} from '../AddressForm';
import StatusLight from '../../global/StatusLight';
import {ContactForm} from '../ContactForm';
import {Toast} from 'primereact/toast';
import CommentHistory from '../../global/CommentHistory';
import {Controller} from 'react-hook-form';
import UnderConstruction from '../../../views/pages/UnderConstruction';
import EditDialogLayout from '../../global/EditDialogLayout';
import FormPrompt from '../../global/FormPrompt';
import {TabPanel, TabView} from 'primereact/tabview';
import moment from 'moment';
import {BankForm} from '../BankForm';
import {CommentForm} from '../CommentForm';
import {moveComments, Person} from '../../functions/GlobalData';
import MapOl from '../../geoData/map';
import LayersMapOl from '../../geoData/layer/LayersMapOl';
import BaseLayers from '../../geoData/layer/BaseLayers';
import PoiLayer from '../../geoData/layer/PoiLayer';
import geoSettings from '../../../config/geoSettings';
import {getMapCenter, isSetAddress} from '../../../functions/functionsOpenlayer';
import {setBaseLayer, setBaseWorkspace, setWorkspace} from '../../../redux/slices/GeomonitoringSlice';
import SingleLayer from '../../geoData/layer/SingleLayer';
import {useGetParcelQuery, useUpdateParcelMutation} from '../../../redux/rtk/injectedParcelApi';
import CautionSign from '../../global/CautionSign';
import {faDatabase, faList, faMapLocation, faProjectDiagram} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ProcessOverview} from '../process/ProcessOverview';
import {UtilisationOverview} from '../../projectMasterData/utilisation/UtilisationOverview';
import {MeasureOverview} from '../../projectMasterData/measure/MeasureOverview';
import {CorrespondenceMapping} from '../correspondence/CorrespondenceMapping';
import {permissions} from '../../../config/permissions';
import {CustomConfirmDialog} from '../../global/CustomConfirmDialog';

type Props = {
    id: string,
    projectId: string,
    data: any,
    // eslint-disable-next-line react/no-unused-prop-types
    setIsDirty: (isDirty: boolean) => void
    onFinished: (success: any) => void
    commonData: boolean,
    geoData: any,
    createNew?: boolean,
    duplicateNew?: boolean,
}

type FormData = {
    strassehausnummer: string,
    plz: number,
    ort: string
}

export const PersonEditForm = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common', 'stammdaten']);

    const mappings: Mapping[] = useAppSelector((state: any) => state.mappingData.mappings);
    const dispatch = useAppDispatch();
    const [skipParcel, setSkipParcel] = React.useState(true);
    const [updateMapping] = useUpdateMappingMutation();
    const [deleteMapping] = useDeleteMappingMutation();
    const [createPerson, resultCreate] = useCreatePersonMutation();
    const [updatePerson, resultUpdate] = useUpdatePersonMutation();
    const {
        data: parcel = []
    } = useGetParcelQuery({
        projectId: props.projectId,
        mapping: props.data ? {person_id: props.data.person_id} : undefined,
        commonData: true
    }, {skipParcel});

    const [triggerHereAddress, resultHereAddress, lastPromiseInfoHereAddress] = useLazyGetHereAddressQuery();
    const hereAddress = resultHereAddress;
    const [data, setData] = useState<any>(props.data);
    const [formData, setFormData] = useState<FormData>();
    const [showUpdateDialog, setShowUpdateDialog] = useState<boolean>(false);
    const [suggestionData, setSuggestionData] = useState<any[]>([]);
    const [selectedSuggestion, setSelectedSuggestion] = useState<Person[]>([]);
    const [height, setHeight] = useState<number>(0);

    const [mappingChanged, setMappingChanged] = useState<boolean>(false);

    const [createNew, setCreateNew] = useState<boolean>(false);
    const [duplicateNew, setDuplicateNew] = useState<boolean>(false);
    const [pois, setPois] = useState<any>({data: {}});
    const [parcelKennz, setParcelKennz] = useState<any>([]);

    const [showNewProcess, setShowNewProcess] = useState<boolean>(false);
    const [newProcess, setNewProcess] = useState<boolean>(false);

    const legalTypesQuery = useGetLegalTypesQuery();
    const legalFormTypesQuery = useGetLegalFormTypesQuery();


    const divRef: any = useRef(null);
    const [center, setCenter] = useState([0, 0]);
    const [zoom, setZoom] = useState(9);
    // eslint-disable-next-line camelcase
    const isCleaned = useCleanArray(formData, {
        person_id: data ? data.person_id : undefined,
        project_id: props.projectId !== '' ? props.projectId : null
    }, props.commonData);

    const defaultValues: Person = {
        'active_id': data ? data.active_id : 0,
        'is_deleted': data ? data.is_deleted : false,
        'benutzer': data ? data.benutzer : [{}],
        'person_id': data ? data.person_id : '',
        'person_dmt_es_id': data ? data.person_dmt_es_id : '',
        'person_vht_id': data ? data.person_vht_id : '',
        'person_verzeichnis_id': data ? data.person_verzeichnis_id : '',
        'juristisch_type_id': data ? data.juristisch_type_id : 0,
        'juristisch_type_name': data ? data.juristisch_type_name : '',
        'juristisch_rechtsform_type_id': data ? data.juristisch_rechtsform_type_id : 0,
        'juristisch_rechtsform_type_name': data ? data.juristisch_rechtsform_type_name : '',
        'name': data ? data.name : '',
        'vorname': data ? data.vorname : '',
        'zweitervorname': data ? data.zweitervorname : '',
        'anrede_type_id': data && data.anrede_type_id != null ? data.anrede_type_id : 0,
        'geburtsdatum': data && data.geburtsdatum != null ? new Date(data.geburtsdatum) : null,
        'akademischergrad': data ? data.akademischergrad : '',
        'praefix': data ? data.praefix : '',
        'adelstitel': data ? data.adelstitel : '',
        'spitzname': data ? data.spitzname : '',
        'suffix': data ? data.suffix : '',
        'geburtsname': data ? data.geburtsname : '',
        'geburtsort': data ? data.geburtsort : '',
        'geburtsort_plz': data ? data.geburtsort_plz : '',
        'strassehausnummer': data ? data.strassehausnummer : '',
        'ort': data ? data.ort : '',
        'mobil_telefon': data ? data.mobil_telefon : '',
        'e_mail': data ? data.e_mail : '',
        'kommentar': '',
        'kommentare': data && data.kommentare ? data.kommentare : [],
        'telefon': data ? data.telefon : '',
        'ersteller': data ? data.ersteller : '',
        'zeitstempel': data ? data.zeitstempel : '',
        'plz': data ? data.plz : '',
        'herkunft': data ? data.herkunft : '',
        'person': data ? data.person : [],
        'flurstueck': data ? data.flurstueck : [],
        'grundbuch': data ? data.grundbuch : [],
        'expandableElement': data ? data.expandableElement : undefined,
        'status_id': data ? data.status_id : 0,
        'ist_juristisch': data ? data.ist_juristisch : false,
        'ist_gestorben': data ? data.ist_gestorben : false,
        'sterbenachweis': data ? data.sterbenachweis : '',
        'sterbedatum': data && data.sterbedatum != null ? new Date(data.sterbedatum) : null,
        'sterbeort': data ? data.sterbeort : '',
        'sterbeort_plz': data ? data.sterbeort_plz : '',
        'homepage': data ? data.homepage : '',
        'dsgvo_date': data && data.dsgvo_date != null ? new Date(data.dsgvo_date) : null,
        'datenweitergabe_date': data && data.datenweitergabe_date != null ? new Date(data.datenweitergabe_date) : null,
        'adresse': data ? data.adresse : [],
        'kontakt': data && data.kontakt ? data.kontakt : [],
        'bank': data && data.bank ? data.bank : [],

        /* 'iban': data ? data.iban : '',
        'bank': data ? data.bank : '',
        'bic': data ? data.bic : '',
        'bank_land': data ? data.bank_land : '',
        'swift': data ? data.swift : '',*/
    };

    const {
        control,
        formState: {errors, isDirty},
        handleSubmit,
        setValue,
        getValues,
        watch,
        reset
    } = useForm({defaultValues});

    const anredeTypId = watch('anrede_type_id');
    const istJuristisch = watch('ist_juristisch');
    const juristischTypeId = watch('juristisch_type_id');
    const juristischRechtsformTypeId = watch('juristisch_rechtsform_type_id');
    const verstorben = watch('ist_gestorben');
    const kommentare = watch('kommentare');
    const geburtsDatum = watch('geburtsdatum');
    const sterbeDatum = watch('sterbedatum');
    const kontakt = watch('kontakt');
    const dsgvo = watch('dsgvo_date');
    const datenweitergabe = watch('datenweitergabe_date');

    const spitzname = watch('spitzname');
    const akademischergrad = watch('akademischergrad');
    const suffix = watch('suffix');
    const praefix = watch('praefix');
    const adelstitel = watch('adelstitel');
    const statusId = watch('status_id');

    const saveData = (data: any, event: any) => {
        data.common_data = props.commonData;
        data = iterateOverKeys(data);

        //   console.log(data, event);
        setFormData(data);
    };

    const getFormErrorMessage = (name: string) => {
        if (name.indexOf('.') >= 0) {
            const split = name.split('.');

            if (split.length === 3) {
                // @ts-ignore
                if (errors[split[0]] && errors[split[0]][split[1]] && errors[split[0]][split[1]][split[2]]) {
                    // @ts-ignore
                    const text = errors[split[0]][split[1]][split[2]].message;

                    showMessageOnError('', text);
                    return <small className="p-error custom">{text}</small>;
                }
            }
        } else {
            // @ts-ignore
            if (errors[name]) {
                // @ts-ignore
                const text = errors[name].message;

                showMessageOnError('', text);

                return <small className="p-error custom">{text}</small>;
            }
        }
        return undefined;
    };

    const createOrUpdatePerson = () => {
        if (data) {
            let map = getMappingsForUpdate('person_id', data.person_id, mappings);

            isCleaned.mappings = map;

            updatePerson(isCleaned).then(async (result: any) => {
                if (!result.error) {
                    if (result.data && result.data === 'vorgang') {
                        setShowNewProcess(true);
                    } else {
                        showMessageOnSuccess(t('globalData:global.personUpdated'), '');
                        props.onFinished(isCleaned);
                        moveComments(getValues, setValue);
                        reset(undefined, {keepValues: true});
                        setMappingChanged(false);
                    }
                }
            });
        } else {
            let map = getMappingsForUpdate('person_id', '', mappings);

            isCleaned.mappings = map;

            createPerson(isCleaned).then(async (result: any) => {
                if (Array.isArray(result.data)) {
                    setSuggestionData(result.data.map((x: any) => x.person_id));
                } else {
                    if (!result.error) {
                        if (result === 'vorgang') {
                            setShowNewProcess(true);
                        } else {
                            showMessageOnSuccess(t('globalData:global.personUpdated'), '');
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                    }
                }
            });
        }
    };

    useEffect(() => {
        if (props.createNew) {
            setCreateNew(props.createNew);
        }
        if (props.duplicateNew) {
            setDuplicateNew(props.duplicateNew);
        }
    }, [props.createNew, props.duplicateNew]);

    useEffect(() => {
        dispatch(resetMappings());
    }, []);

    useEffect(() => {
        props.setIsDirty(isDirty || mappingChanged);
    }, [isDirty, mappingChanged]);

    useEffect(() => {
        if (divRef.current) {
            setHeight(divRef.current.parentElement.clientHeight);
        }
    }, [divRef.current]);

    useEffect(() => {
        if (formData)
            createOrUpdatePerson();
    }, [formData]);

    useEffect(() => {
        setShowUpdateDialog(suggestionData.length > 0);
    }, [suggestionData]);

    useEffect(() => {
        if (createNew) {
            setCreateNew(false);
            setData(undefined);
            reset({
                'person_id': '',
                'person_dmt_es_id': '',
                'person_vht_id': '',
                'person_verzeichnis_id': '',
                'juristisch_type_id': 0,
                'juristisch_type_name': '',
                'juristisch_rechtsform_type_id': 0,
                'juristisch_rechtsform_type_name': '',
                'name': '',
                'vorname': '',
                'zweitervorname': '',
                'anrede_type_id': 0,
                'geburtsdatum': null,
                'akademischergrad': '',
                'praefix': '',
                'adelstitel': '',
                'spitzname': '',
                'suffix': '',
                'geburtsname': '',
                'geburtsort': '',
                'geburtsort_plz': '',
                'strassehausnummer': '',
                'ort': '',
                'mobil_telefon': '',
                'e_mail': '',
                'kommentar': '',
                'kommentare': [],
                'telefon': '',
                'ersteller': '',
                'zeitstempel': new Date(),
                'plz': undefined,
                'herkunft': '',
                'person': [],
                'flurstueck': [],
                'grundbuch': [],
                'expandableElement': undefined,
                'status_id': 0,
                'ist_juristisch': false,
                'ist_gestorben': false,
                'sterbenachweis': '',
                'sterbedatum': null,
                'sterbeort': '',
                'sterbeort_plz': '',
                'homepage': '',
                'adresse': [],
                'kontakt': [],
                'bank': []
            });
            showMessageOnSuccess('', t('globalData:toasts.createNewMessage'));
        }
    }, [createNew]);

    useEffect(() => {
        if (duplicateNew) {
            setDuplicateNew(false);
            reset(undefined, {keepValues: true});
            showMessageOnSuccess('', t('globalData:toasts.duplicateNewMessage'));
        }
    }, [duplicateNew]);

    const hideUpdateDialog = () => {
        setShowUpdateDialog(false);
    };

    const onSelection = (selection: Person[]) => {
        setSelectedSuggestion(selection);
    };

    const personOverwrite = () => {
        createPerson({
            ...isCleaned,
            newdataset: false,
            person_id: selectedSuggestion[0].person_id
        }).then(async (result: any) => {
            if (!result.error) {
                if (await saveMappings('person_id', selectedSuggestion[0].person_id, mappings, updateMapping, deleteMapping)) {
                    showMessageOnSuccess(t('globalData:global.personUpdated'), '');
                    hideUpdateDialog();
                    props.onFinished(isCleaned);
                }
            }
        });
    };

    const personNew = () => {
        createPerson({...isCleaned, newdataset: true}).then((result: any) => {
            if (!result.error) {
                showMessageOnSuccess(t('globalData:global.personUpdated'), '');
                hideUpdateDialog();
                props.onFinished(isCleaned);
            }
        });
    };

    const getStatus = () => {
        return (
            <StatusLight id={'statuslight-personeditform'} value={statusId} info={'Testinfo'} light={false}
                         horizontal={false}
                         caution={false}/>);
    };

    // Accordion Headlines --->

    const getAdditionalnamesAccordionHeadline = () => {
        const right = `${spitzname || ''} ${akademischergrad || ''} ${suffix || ''} ${praefix || ''} ${adelstitel || ''}`;

        return (<div className={'grid grid-nogutter'}>
            <div className={'col'}>{t('globalData:persons.nameAdditions')}</div>
            <div className={'col-auto text-right accordion-addition'}>{right}</div>
        </div>);
    };

    const getAddressAccordionHeadline = () => {
        let right = '';
        if (data && data.adresse && data.adresse.length > 0) {

            for (let i = 0; i < data.adresse.length; i++) {
                const adresse = data.adresse[i];

                if (istJuristisch && adresse.adresse_type_id >= 7) {
                    right = `${adresse.strassehausnummer}, ${adresse.plz} ${adresse.ort}`;
                    break;
                } else if (!istJuristisch && adresse.adresse_type_id < 7) {
                    right = `${adresse.strassehausnummer}, ${adresse.plz} ${adresse.ort}`;
                    break;
                }
            }
        }

        return (<div className={'grid grid-nogutter'}>
            <div className={'col'}>{t('globalData:persons.addressDetails')}</div>
            <div className={'col-auto text-right accordion-addition'}>{right}</div>
        </div>);
    };

    const getContactAccordionHeadline = () => {
        let right = '';
        if (kontakt) {
            for (let i = 0; i < kontakt.length; i++) {
                const k = kontakt[i];

                if (k.hauptkontakt) {
                    right = `${k.value}`;
                    break;
                }
            }
        }

        return (<div className={'grid grid-nogutter'}>
            <div className={'col'}>{t('globalData:persons.contact')}</div>
            <div className={'col-auto text-right accordion-addition'}>{right}</div>
        </div>);
    };

    const getBirthAndDeathAccordionHeadline = () => {
        let right = '';

        if (geburtsDatum) {
            right = '*' + moment(geburtsDatum).format(t('dateformat'));
        }
        if (sterbeDatum != null) {
            right += ' +' + moment(sterbeDatum).format(t('dateformat'));
        }

        return (<div className={'grid grid-nogutter'}>
            <div className={'col'}>{t('globalData:persons.birthAndDeath')}</div>
            <div className={'col-auto text-right accordion-addition'}>{right}</div>
        </div>);
    };

    const getBankAccordionHeadline = () => {
        let right = '';

        if (data && data.bank && data.bank.length > 0) {
            right = data.bank[0].iban;
        }

        return (<div className={'grid grid-nogutter'}>
            <div className={'col'}>{t('globalData:persons.bankDetails')}</div>
            <div className={'col-auto text-right accordion-addition'}>{right}</div>
        </div>);
    };

    const getLegitimationAccordionHeadline = () => {
        return (<div className={'grid grid-nogutter'}>
            <div className={'col'}>{t('globalData:persons.legitimation')}</div>
            <div className={'col-auto text-right'}>
                <div className={'flex'}>
                    {dsgvo && <div className={'flex'}>
                        <div>{t('globalData:persons.dsgvo_short') + ': '}</div>
                        <i className={classNames('ml-2 mr-3', 'pi pi-check')}/>
                    </div>}
                    {datenweitergabe && <div className={'flex'}>
                        <div>{t('globalData:persons.datenweitergabe_short') + ': '}</div>
                        <i className={classNames('ml-2', 'pi pi-check')}/>
                    </div>}
                </div>
            </div>
        </div>);
    };

    const getCommentAccordionHeadline = () => {
        let right = '';

        if (kommentare && kommentare.length > 0) {
            right = t('lastEntry') + ': ' + moment(kommentare[0].zeitstempel).format(t('datetimeformat'));
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('comments') + (kommentare && kommentare.length > 0 ? ` (${kommentare.length})` : '')}</div>
            <div className={'col-auto text-right'}>{right}</div>
        </div>);
    };

    // <--- Accordion Headlines

    const validateAddress = (index: number, data: any) => {
        if (data.adresse && data.adresse.length > 0) {
            let currentAdress = data.adresse[index];
            if (isSetAddress(currentAdress)) {
                currentAdress = {...currentAdress, ...{index: index}};
                triggerHereAddress(currentAdress);

                // setShowAddressDialog(true);
            }
        }
    };

    const getMapCenterData = () => {
        const baseWorkspace = props.geoData.baselayer_workspace !== null ? props.geoData.baselayer_workspace : geoSettings.wmsWorkspace;
        const mapCenterData = getMapCenter({project: props.geoData});
        setZoom(mapCenterData.zoom);
        setCenter(mapCenterData.center);
    };


    const getTypeDataHere = (index: number) => {
        let type = {};
        // console.log(poisArray.data);
        if (props.data.adresse && props.data.adresse[index]) {
            const address = props.data.adresse[index];
            type = {
                adresse_type_id: address.adresse_type_id,
                ladungsadresse: address.ladungsadresse,
                postadresse: address.postadresse
            };
        }
        return type;
    };

    const setPoisData = (index: number, position: any) => {
        const poisArray = pois;
        const type = getTypeDataHere(index);
        poisArray.data[index] = {position: position, typeData: type, index: index};
        setPois({data: {...{}, ...poisArray.data}, index: index});
    };

    useEffect(() => {

        const parcelKennzArray: any[] = [];
        parcel.forEach((p: any) => {
            if (p.flstkennz !== null) {
                parcelKennzArray.push(p.flstkennz);
            }

        });
        // console.log(parcel, props.data, parcelKennzArray);
        setParcelKennz(parcelKennzArray);
    }, [parcel]);

    useEffect(() => {
        getMapCenterData();
        setSkipParcel(false);
    }, []);

    useEffect(() => {
        if (props.data && props.data.adresse !== null) {
            const transferGeoPositon = () => {
                //      console.log('transfer', props.addressData)
                for (const i in props.data.adresse) {
                    const address = props.data.adresse[i];
                    const geoPosition = address.geo_position;
                    const type = {
                        adresse_type_id: address.adresse_type_id,
                        ladungsadresse: address.ladungsadresse,
                        postadresse: address.postadresse
                    };
                    if (geoPosition !== null) {
                        const data = {
                            position: {lng: geoPosition.coordinates[0], lat: geoPosition.coordinates[1]},
                            index: i,
                            typeData: type
                        };
                        const poisArray = pois;

                        poisArray.data[i] = data;
                        console.log({data: {...{}, ...poisArray.data}, index: 0});
                        setPois({data: {...{}, ...poisArray.data}, index: 0});
                    } else {
                        //   console.log('validate')
                        validateAddress(parseInt(i), getValues());
                    }

                }
            };
            setTimeout(transferGeoPositon, 2000);
        }
    }, [props.data]);

    useEffect(() => {
            //   console.log(hereAddress);
            if (hereAddress.isSuccess && hereAddress.data.found) {
                //          console.log(pois,hereAddress.data)
                setPoisData(hereAddress.data.index, hereAddress.data.position);

            }
        },
        [hereAddress.data]);
    return (<div className={'relative h-full'}>
            <form ref={divRef} id={props.id} onSubmit={handleSubmit(saveData)} className={'h-full'}>
                <FormPrompt hasUnsavedChanges={isDirty || mappingChanged}/>
                <EditDialogLayout
                    left={<>
                        {/* <h4>{t('globalData:global.generalData')}</h4>*/}
                        <div className={'grid'}>
                            <div className={'col-12 md:col-6 grid grid-nogutter'}>
                                <div className={'grid grid-nogutter col-6'}>
                                    <div className={'col-fixed'}>
                                        {getStatus()}
                                    </div>
                                    <div className={'col pl-2'}>
                                        <div className={'p-1'}>
                                            <RadioButton className={'mr-2'}
                                                         inputId={'ist_juristisch_false'}
                                                         value={false} name="ist_juristisch"
                                                         onChange={() => {
                                                             setValue('ist_juristisch', false);
                                                         }}
                                                         checked={!istJuristisch}
                                                         disabled={!checkPermission(permissions.editPersons)}/>
                                            <label
                                                htmlFor="ist_juristisch_false">{t('globalData:persons.natuerlich')}</label>
                                        </div>
                                        <div className={'p-1'}>
                                            <RadioButton className={'mr-2'}
                                                         inputId={'ist_juristisch_true'}
                                                         value={true}
                                                         name="ist_juristisch"
                                                         onChange={() => {
                                                             setValue('ist_juristisch', true);
                                                         }}
                                                         checked={istJuristisch}
                                                         disabled={!checkPermission(permissions.editPersons)}/>
                                            <label
                                                htmlFor="ist_juristisch_true">{t('globalData:persons.ist_juristisch')}</label>
                                        </div>
                                    </div>
                                </div>
                                {!istJuristisch && <div className={'col-6'}>
                                    <>
                                        <div className={'p-1'}>
                                            <Controller name="anrede_type_id" control={control}
                                                        rules={{
                                                            min: {
                                                                value: 1,
                                                                message: t('globalData:persons.geschlecht') + ' ' + t('input:required')
                                                            },
                                                            required: t('globalData:persons.geschlecht') + ' ' + t('input:required')
                                                        }}
                                                        render={({field, fieldState}) => (
                                                            <RadioButton
                                                                className={classNames('mr-2', errors['anrede_type_id'] ? 'error' : '')}
                                                                value={1}
                                                                inputId={'anrede_type_id_1'}
                                                                name="anrede_type_id"
                                                                onChange={(e) => {
                                                                    field.onChange(1);
                                                                }}
                                                                checked={anredeTypId === 1}
                                                                disabled={!checkPermission(permissions.editPersons)}/>)}/>
                                            <label
                                                htmlFor={'anrede_type_id_1'}>{t('globalData:persons.sex1')}</label>
                                        </div>
                                        <div className={'p-1'}>
                                            <Controller name="anrede_type_id" control={control}
                                                        rules={{
                                                            min: {
                                                                value: 1,
                                                                message: t('globalData:persons.geschlecht') + ' ' + t('input:required')
                                                            },
                                                            required: t('globalData:persons.geschlecht') + ' ' + t('input:required')
                                                        }}
                                                        render={({field, fieldState}) => (
                                                            <RadioButton
                                                                className={classNames('mr-2', errors['anrede_type_id'] ? 'error' : '')}
                                                                value={'2'}
                                                                inputId={'anrede_type_id_2'}
                                                                name="anrede_type_id"
                                                                onChange={(e) => {
                                                                    field.onChange(2);
                                                                }}
                                                                checked={anredeTypId === 2}
                                                                disabled={!checkPermission(permissions.editPersons)}/>)}/>
                                            <label
                                                htmlFor={'anrede_type_id_2'}>{t('globalData:persons.sex2')}</label>
                                        </div>
                                        <div className={'p-1'}>
                                            <Controller name="anrede_type_id" control={control}
                                                        rules={{
                                                            min: {
                                                                value: 1,
                                                                message: t('globalData:persons.geschlecht') + ' ' + t('input:required')
                                                            },
                                                            required: t('globalData:persons.geschlecht') + ' ' + t('input:required')
                                                        }}
                                                        render={({field, fieldState}) => (
                                                            <RadioButton
                                                                className={classNames('mr-2', errors['anrede_type_id'] ? 'error' : '')}
                                                                value={'3'}
                                                                inputId={'anrede_type_id_3'}
                                                                name="anrede_type_id"
                                                                onChange={(e) => {
                                                                    field.onChange(3);
                                                                }}
                                                                checked={anredeTypId === 3}
                                                                disabled={!checkPermission(permissions.editPersons)}/>)}/>
                                            <label
                                                htmlFor={'anrede_type_id_3'}>{t('globalData:persons.sex3')}</label>
                                        </div>
                                    </>
                                    {errors['anrede_type_id'] && <small
                                        className="p-error custom text-center w-full">{errors['anrede_type_id'].message}</small>}
                                </div>}

                                {istJuristisch && <div className={'col-6'}>
                                    <>
                                        {legalTypesQuery.data && legalTypesQuery.data.map((item: any) => {
                                            return (<div className={'p-1'}>
                                                <Controller name="juristisch_type_id" control={control}
                                                            rules={{
                                                                min: {
                                                                    value: 1,
                                                                    message: t('globalData:persons.juristisch_type_name') + ' ' + t('input:required')
                                                                },
                                                                required: t('globalData:persons.juristisch_type_name') + ' ' + t('input:required')
                                                            }}
                                                            render={({field, fieldState}) => (
                                                                <RadioButton
                                                                    className={classNames('mr-2', errors['juristisch_type_id'] ? 'error' : '')}
                                                                    value={item.id}
                                                                    inputId={'juristisch_type_id_' + item.id}
                                                                    name="juristisch_type_id"
                                                                    onChange={(e) => {
                                                                        field.onChange(item.id);
                                                                    }}
                                                                    checked={juristischTypeId === item.id}
                                                                    disabled={!checkPermission(permissions.editPersons)}/>)}/>
                                                <label
                                                    htmlFor={'juristisch_type_id_' + item.id}>{item.name}</label>
                                            </div>);
                                        })}
                                        {errors['juristisch_type_id'] &&
                                            <small
                                                className="p-error custom text-center w-full">{errors['juristisch_type_id'].message}</small>}
                                    </>
                                </div>}
                            </div>
                            <div className={'col-12 md:col-6 px-0'}>
                                {props.projectId && <>
                                    <div className={'col-12'}>
                                        <Input
                                            edit={false} label={t('globalData:persons.personDmtEsId')}
                                            name={'person_dmt_es_id'}
                                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                                            validationRules={{
                                                required: false,
                                                // required: t('globalData:persons.firstName') + ' ' + t('input:required')
                                            }}
                                        />
                                    </div>
                                </>}
                            </div>
                        </div>
                        <div className={'grid'}>
                            <div className={'col-12 md:col-6'}>
                                <Input
                                    edit={checkPermission(permissions.editPersons)}
                                    label={t('globalData:persons.personVerzeichnisId')}
                                    name={'person_verzeichnis_id'}
                                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                                    validationRules={{
                                        required: false,
                                        // required: t('globalData:persons.firstName') + ' ' + t('input:required')
                                    }}
                                />
                            </div>
                            <div className={'col-12 md:col-6'}>
                                <Input
                                    edit={checkPermission(permissions.editPersons)}
                                    label={t('globalData:persons.personVhtId')}
                                    name={'person_vht_id'}
                                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                                    validationRules={{
                                        required: false,
                                        // required: t('globalData:persons.firstName') + ' ' + t('input:required')
                                    }}
                                />
                            </div>
                        </div>
                        <hr/>
                        <div className={'grid'}>
                            <div className={'col-12 md:col-6'}>
                                <Input
                                    edit={checkPermission(permissions.editPersons)}
                                    label={t(`globalData:persons.${istJuristisch ? 'companyName' : 'lastName'}`)}
                                    name={'name'}
                                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                                    validationRules={{
                                        required: t('globalData:persons.name') + ' ' + t('input:required')
                                    }}
                                />
                            </div>
                            <div className={'col-12 md:col-6'}>
                                {!istJuristisch && <Input
                                    edit={checkPermission(permissions.editPersons)}
                                    label={t('globalData:persons.birthName')}
                                    name={'geburtsname'}
                                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                                    validationRules={{required: false}}
                                />}
                                {istJuristisch &&
                                    <Input
                                        edit={checkPermission(permissions.editPersons)}
                                        label={t('globalData:persons.juristisch_rechtsform_type_name')}
                                        name={'juristisch_rechtsform_type_id'}
                                        type={'dropdown'}
                                        dropdownOptions={legalFormTypesQuery.data?.map((item: any) => {
                                            return {
                                                label: item.name,
                                                value: item.id
                                            };
                                        })}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{required: false}}
                                    />}
                            </div>
                        </div>
                        {!istJuristisch && <div className={'grid'}>
                            <div className={'col-12 md:col-6'}>
                                <Input
                                    edit={checkPermission(permissions.editPersons)}
                                    label={t('globalData:persons.firstName')}
                                    name={'vorname'}
                                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                                    validationRules={{
                                        required: false,
                                        // required: t('globalData:persons.firstName') + ' ' + t('input:required')
                                    }}
                                />
                            </div>
                            <div className={'col-12 md:col-6'}>
                                <Input
                                    edit={checkPermission(permissions.editPersons)}
                                    label={t('globalData:persons.middleName')}
                                    name={'zweitervorname'}
                                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                                    validationRules={{
                                        required: false,
                                        // required: t('globalData:persons.firstName') + ' ' + t('input:required')
                                    }}
                                />
                            </div>
                        </div>}

                        <br/>

                        {!istJuristisch && <><Accordion>
                            <AccordionTab header={getAdditionalnamesAccordionHeadline()}>
                                <div className={'grid'}>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.academicaldegree')}
                                            name={'akademischergrad'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.adelstitel')}
                                            name={'adelstitel'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.suffix')}
                                            name={'suffix'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.praefix')}
                                            name={'praefix'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.spitzname')}
                                            name={'spitzname'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                </div>
                            </AccordionTab>
                        </Accordion><br/></>}

                        <Accordion>
                            <AccordionTab header={getAddressAccordionHeadline()}>
                                <AddressForm projectId={props.projectId} t={t}
                                             getFormErrorMessage={getFormErrorMessage}
                                             form={{
                                                 control,
                                                 formState: {errors},
                                                 handleSubmit,
                                                 setValue,
                                                 getValues,
                                                 watch
                                             }}
                                             istJuristisch={istJuristisch}
                                             edit={checkPermission(permissions.editPersons)}
                                             addressData={data ? data.adresse : null}
                                             geoData={props.geoData}
                                />
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion activeIndex={0}>
                            <AccordionTab header={getContactAccordionHeadline()}>
                                <ContactForm projectId={props.projectId} t={t}
                                             getFormErrorMessage={getFormErrorMessage}
                                             form={{
                                                 control,
                                                 formState: {errors},
                                                 handleSubmit,
                                                 setValue,
                                                 getValues,
                                                 watch
                                             }}
                                             istJuristisch={istJuristisch}
                                             edit={checkPermission(permissions.editPersons)}/>
                                {/* <div className={'grid'}>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.phone')}*/}
                                {/*            name={'telefon'}*/}
                                {/*            validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.fax')} name={'fax'}*/}
                                {/*            validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/* </div>*/}

                                {/* {!istJuristisch && <div className={'grid'}>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.email')}*/}
                                {/*            name={'e_mail'}*/}
                                {/*            validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.mobilPhone')}*/}
                                {/*            name={'mobil_telefon'}*/}
                                {/*            validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/* </div>}*/}

                                {/* {istJuristisch &&*/}
                                {/* <div className={'grid'}>*/}
                                {/*    <div className={'col-12'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.homepage')}*/}
                                {/*            name={'homepage'}*/}
                                {/*            validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/* </div>}*/}
                            </AccordionTab>
                        </Accordion>
                        <br/>

                        {!istJuristisch && <><Accordion>
                            <AccordionTab header={getBirthAndDeathAccordionHeadline()}>
                                <div className={'grid'}>
                                    <div className={'col-12 md:col-6'}>
                                    </div>
                                    <div className={'col-6 grid grid-nogutter'}>
                                        <div className={'col-12 md:col-6'}><Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.ist_gestorben')}
                                            name={'ist_gestorben'}
                                            noMargin={true}
                                            type={'checkbox'}
                                            showTime={false}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{
                                                // required: t('globalData:persons.birthDate') + ' ' + t('input:required'),
                                                required: false
                                            }}
                                        /></div>
                                        <div className={'col-12 md:col-6'}><Button disabled={true}
                                                                                   label={t('globalData:buttons.heritageResearch')}/>
                                        </div>
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.birthDate')}
                                            name={'geburtsdatum'}
                                            type={'date'}
                                            showTime={false}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{
                                                // required: t('globalData:persons.birthDate') + ' ' + t('input:required'),
                                                required: false
                                            }}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.sterbedatum')}
                                            name={'sterbedatum'}
                                            type={'date'}
                                            showTime={false}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.birthPlace')}
                                            name={'geburtsort'}

                                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.sterbeort')}
                                            name={'sterbeort'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.birthPlacePlz')}
                                            name={'geburtsort_plz'}

                                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                    <div className={'col-12 md:col-6'}>
                                        <Input
                                            edit={checkPermission(permissions.editPersons)}
                                            label={t('globalData:persons.sterbeort_plz')}
                                            name={'sterbeort_plz'}
                                            validationControl={control}
                                            validationErrorMessage={getFormErrorMessage}
                                            validationRules={{required: false}}
                                        />
                                    </div>
                                </div>
                            </AccordionTab>
                        </Accordion> <br/></>}
                        <Accordion>
                            <AccordionTab header={getBankAccordionHeadline()}>
                                <BankForm projectId={props.projectId} t={t} getFormErrorMessage={getFormErrorMessage}
                                          form={{
                                              control,
                                              formState: {errors},
                                              handleSubmit,
                                              setValue,
                                              getValues,
                                              watch
                                          }} edit={checkPermission(permissions.editPersons)}/>
                                {/* <div className={'grid'}>*/}
                                {/*    <div className={'col-12'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.iban')}*/}
                                {/*            name={'iban'}*/}
                                {/*            validationControl={control}*/}
                                {/*            validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.bank')}*/}
                                {/*            name={'bank'}*/}
                                {/*            validationControl={control}*/}
                                {/*            validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.bic')} name={'bic'}*/}
                                {/*            validationControl={control}*/}
                                {/*            validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.bank_land')} name={'bank_land'}*/}
                                {/*            validationControl={control}*/}
                                {/*            validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-12 md:col-6'}>*/}
                                {/*        <Input*/}
                                {/*            edit={checkPermission(permissions.editPersons)} label={t('globalData:persons.swift')} name={'swift'}*/}
                                {/*            validationControl={control}*/}
                                {/*            validationErrorMessage={getFormErrorMessage}*/}
                                {/*            validationRules={{required: false}}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/* </div>*/}
                            </AccordionTab>
                        </Accordion>
                        {!istJuristisch && <>
                            <br/>
                            <Accordion>
                                <AccordionTab header={getLegitimationAccordionHeadline()}>
                                    <div className={'grid'}>
                                        <div className={'col-12 md:col-6'}>
                                            <Input
                                                edit={checkPermission(permissions.editPersons)}
                                                label={t('globalData:persons.dsgvo_date')}
                                                name={'dsgvo_date'}
                                                type={'date'}
                                                showTime={false}
                                                validationControl={control}
                                                validationErrorMessage={getFormErrorMessage}
                                                validationRules={{required: false}}
                                            />
                                        </div>
                                        <div className={'col-12 md:col-6'}>
                                            <Input
                                                edit={checkPermission(permissions.editPersons)}
                                                label={t('globalData:persons.datenweitergabe_date')}
                                                name={'datenweitergabe_date'}
                                                type={'date'}
                                                showTime={false}
                                                validationControl={control}
                                                validationErrorMessage={getFormErrorMessage}
                                                validationRules={{required: false}}
                                            />
                                        </div>
                                    </div>
                                </AccordionTab>
                            </Accordion>
                        </>}
                        <br/>
                        <Accordion>
                            <AccordionTab
                                header={getCommentAccordionHeadline()}>
                                <CommentForm projectId={props.projectId} t={t} type={'person'}
                                             getFormErrorMessage={getFormErrorMessage}
                                             form={{
                                                 control,
                                                 formState: {errors},
                                                 handleSubmit,
                                                 setValue,
                                                 getValues,
                                                 watch
                                             }} edit={checkPermission(permissions.editPersons)}
                                             kommentare={kommentare}/>
                            </AccordionTab>
                        </Accordion>
                        <br/>
                        <Accordion>
                            <AccordionTab header={t('documents')}>
                                <UnderConstruction/>
                            </AccordionTab>
                        </Accordion>
                    </>}
                    right={
                        props.commonData ? <TabView activeIndex={2} renderActiveOnly={false}>
                            <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                    icon={faMapLocation}/>{t('tabs.geoMap')}
                            </div>}>
                                <MapOl key={'adresspreview_maps'} zoom={zoom} center={center} divHeight={'75vH'}
                                       toolkitEnabled={false}
                                       position={'relative'}
                                       propElem={/* {project: {id:props.projectId, base_layer:'osmger'}}*/{project: props.geoData}}>
                                    <LayersMapOl key={props.projectId + '_layerMaps'}>
                                        <BaseLayers projectId={props.projectId}
                                                    mapDataWorkBench={props.geoData.baselayer_workspace}
                                                    baseLayer={props.geoData.baseLayer ? props.geoData.baseLayer : 'gm_layer_maps'}/>
                                        <PoiLayer pois={pois} zoomTo={null}/>
                                        <SingleLayer layerName={geoSettings.parcelLayer} workspace={'rightguard'}
                                                     styleName={null} layerKind={'vectorData'}
                                                     featureKennz={parcelKennz}/>
                                    </LayersMapOl>
                                </MapOl>
                            </TabPanel>
                            {props.projectId && <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                                          icon={faDatabase}/>{t('tabs.relationshipProjectMasterData')}
                            </div>}>
                                <br/>
                                {checkPermission(permissions.seeMeasures) && <><Accordion activeIndex={0}>
                                    <AccordionTab header={t('projectMasterData:measures.plural')}>
                                        <MeasureOverview
                                            projectId={props.projectId}
                                            mapping={data ? {person_id: data.person_id} : {}}
                                            editable={false}
                                            expandable={false}
                                            hideGlobalFilter={false}
                                            showColumnFilters={true}
                                            hideButtons={true}
                                            skeletonCount={1}
                                            showHeader={false}
                                            skip={!data}
                                        />
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {checkPermission(permissions.seeUtilisation) && <><Accordion activeIndex={0}>
                                    <AccordionTab header={t('projectMasterData:utilisation.plural')}>
                                        <UtilisationOverview
                                            projectId={props.projectId}
                                            mapping={data ? {person_id: data.person_id} : {}}
                                            editable={false}
                                            expandable={false}
                                            hideGlobalFilter={false}
                                            showColumnFilters={true}
                                            hideButtons={true}
                                            skeletonCount={1}
                                            showHeader={false}
                                            skip={!data}
                                        />
                                    </AccordionTab>
                                </Accordion></>}
                            </TabPanel>}
                            <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                    icon={faProjectDiagram}/>{t('tabs.relationshipProjectProcessing')}
                            </div>}>
                                <br/>
                                {props.projectId && checkPermission(permissions.seeProcess) && <><Accordion
                                    activeIndex={0}>
                                    <AccordionTab header={t('globalData:process.plural')}>
                                        <ProcessOverview
                                            showParcels={false}
                                            showPersons={false}
                                            showLandRegisters={false}
                                            projectId={props.projectId}
                                            mapping={data ? {person_id: data.person_id} : {}}
                                            editable={false}
                                            expandable={false}
                                            hideGlobalFilter={false}
                                            showColumnFilters={true}
                                            skeletonCount={1}
                                            showHeader={false}
                                            skip={!data}
                                            isDirty={isDirty || mappingChanged}
                                        />
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {checkPermission(permissions.seePersons) && <><Accordion activeIndex={0}>
                                    <AccordionTab header={t('globalData:global.personen')}>
                                        <PersonMapping projectId={props.projectId}
                                                       mappingId={data ? data.person_id : ''}
                                                       mappingType={MappingType.personPerson}
                                            // dataIds={data && data.person ? data.person : []}
                                            // scrollHeight={`${height / 2 - 150}px`}
                                                       showHeader={false} skip={!data}
                                                       onChange={() => {
                                                           setMappingChanged(true);
                                                       }}
                                                       isDirty={isDirty || mappingChanged}/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {checkPermission(permissions.seeParcels) && <><Accordion activeIndex={0}>
                                    <AccordionTab header={t('globalData:global.flurstuecke')}>
                                        <ParcelMapping projectId={props.projectId}
                                                       mappingId={data ? data.person_id : ''}
                                                       mappingType={MappingType.personParcel}
                                                       hideButtons={true}
                                                       showHeader={false} skip={!data}
                                                       onChange={() => {
                                                           setMappingChanged(true);
                                                       }}
                                                       isDirty={isDirty || mappingChanged}/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {checkPermission(permissions.seeLandregister) && <><Accordion activeIndex={0}>
                                    <AccordionTab header={t('globalData:global.landRegisters')}>
                                        <LandRegisterMapping projectId={props.projectId}
                                                             mappingId={data ? data.person_id : ''}
                                                             mappingType={MappingType.personLandRegister}
                                            // dataIds={data && data.grundbuch ? data.grundbuch : []}
                                            // scrollHeight={`${height / 3 - 150}px`}
                                                             showHeader={false} skip={!data}
                                                             onChange={() => {
                                                                 setMappingChanged(true);
                                                             }}
                                                             isDirty={isDirty || mappingChanged}/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {props.projectId && <><Accordion>
                                    <AccordionTab disabled={true} header={t('globalData:global.ecoAccounts')}>
                                        <UnderConstruction/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {props.projectId && <><Accordion>
                                    <AccordionTab disabled={true} header={t('globalData:global.research')}>
                                        <UnderConstruction/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {props.projectId && checkPermission(permissions.seeCorrespondence) &&
                                    <><Accordion>
                                        <AccordionTab header={t('correspondence:plural')}>
                                            <CorrespondenceMapping projectId={props.projectId}
                                                                   mappingId={data ? data.person_id : ''}
                                                                   mappingType={MappingType.personCorrespondence}
                                                                   skip={!data}
                                                                   onChange={() => {
                                                                       setMappingChanged(true);
                                                                   }}/>
                                        </AccordionTab>
                                    </Accordion>
                                        <br/></>}
                                {props.projectId && <><Accordion>
                                    <AccordionTab disabled={true} header={t('contract:pluralShort')}>
                                        <UnderConstruction/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {props.projectId && <><Accordion>
                                    <AccordionTab disabled={true} header={t('globalData:global.legalProceedings')}>
                                        <UnderConstruction/>
                                    </AccordionTab>
                                </Accordion>
                                    <br/></>}
                                {props.projectId &&
                                    <><Accordion>
                                        <AccordionTab disabled={true} header={t('payment:plural')}>
                                            <UnderConstruction/>
                                        </AccordionTab>
                                    </Accordion>
                                        <br/></>}
                                {props.projectId &&
                                    <Accordion>
                                        <AccordionTab disabled={true} header={t('invoice:plural')}>
                                            <UnderConstruction/>
                                        </AccordionTab>
                                    </Accordion>}
                            </TabPanel>
                            <TabPanel disabled={true} header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                                    icon={faList}/>{t('tabs.relationshipProjectManagement')}
                            </div>}>
                            </TabPanel>
                        </TabView> : undefined
                    }/>
            </form>
            <CustomDialog onCancel={hideUpdateDialog} visible={showUpdateDialog} showFooter={false}
                          header={t('globalData:global.personFoundHeader')}>
                <div>
                    <p>{t('globalData:global.personFound')}</p>
                    <PersonOverview projectId={props.projectId}
                                    showParcels={false}
                                    showPersons={false}
                                    showLandRegisters={false}
                                    showShareInfos={false}
                                    showSuggestions={false}
                                    dataIds={suggestionData} editable={false} expandable={false}
                                    hideGlobalFilter={true} commonData={true}
                                    showColumnFilters={false}
                                    hideButtons={true}
                                    hideAddButton={true}
                                    selectable={true} onSelection={onSelection}
                                    geoData={props.geoData}
                    />
                    <div className={'grid w-full mt-2'}>
                        <div className={'col'}><Button type={'button'} disabled={selectedSuggestion.length <= 0}
                                                       label={t('globalData:global.personOverwrite')}
                                                       onClick={personOverwrite}/></div>
                        <div className={'col'}><Button type={'button'}
                                                       label={t('globalData:global.personNew')}
                                                       onClick={personNew}/></div>
                    </div>
                </div>
            </CustomDialog>
            {showNewProcess && <CustomDialog
                onClick={() => {
                    let createOrUpdate = props.data ? updatePerson : createPerson;

                    isCleaned.mappings = getMappingsForUpdate('person_id', props.data ? props.data.person_id : '', mappings);
                    isCleaned.neuer_vorgang = newProcess;
                    createOrUpdate(isCleaned).then(async (result: any) => {
                        if (!result.error) {
                            setNewProcess(false);
                            showMessageOnSuccess(t('globalData:global.parcelUpdated'), '');
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                        setShowNewProcess(false);
                    });
                }}
                onCancel={() => {
                    showMessageOnError(t('globalData:dialogs.newProcessCanceled'), t('globalData:dialogs.newProcessParcelNotSaved'));
                    setShowNewProcess(false);
                    setNewProcess(false);
                }} visible={showNewProcess} header={t('globalData:dialogs.newProcessDialog')}>
                <div>
                    <p>{t('globalData:dialogs.newProcessDialogMessage')}</p>
                    <div className={'col pl-2'}>
                        <div className={'p-1'}>
                            <RadioButton className={'mr-2'}
                                         inputId={'new_process_false'}
                                         value={false} name="new_process"
                                         onChange={() => {
                                             setNewProcess(false);
                                         }}
                                         checked={!newProcess}/>
                            <label
                                htmlFor="new_process_false">{t('globalData:dialogs.newProcessDialogMessage1')}</label>
                        </div>
                        <div className={'p-1'}>
                            <RadioButton className={'mr-2'}
                                         inputId={'new_process_true'}
                                         value={true}
                                         name="new_process"
                                         onChange={() => {
                                             setNewProcess(true);
                                         }}
                                         checked={newProcess}/>
                            <label
                                htmlFor="new_process_true">{t('globalData:dialogs.newProcessDialogMessage2')}</label>
                        </div>
                    </div>
                </div>
            </CustomDialog>}
        </div>
    );
};
